<template>
  <form :data-vv-scope="$route.name">
    <div class="container">
      <div class="jobmatch_fv">
        <div class="inner_fv">
          <img src="@assets/images/business_aptitudes/jobmatch_banner_pc.png" class="sp_hidden">
          <img src="@assets/images/business_aptitudes/jobmatch_banner_sp.png" class="pc_hidden">
        </div>
      </div>

      <div class="jobmatch_main_area">
        <p class="faq_txt_intr">あなたが将来働く姿に当てはまるものを<br class="view_sp">1つ選んでください</p>

        <router-view v-slot="{ Component, route }">
          <div class="step">
            <progress :value="route.meta.order" :max="questionsStore.questionAllCount" class="gauge" />
            <p class="step_num">{{ route.meta.order }}/{{ questionsStore.questionAllCount }}</p>
          </div>

          <transition name="jobmatch" mode="out-in">
            <component :is="Component" :key="route.path" @handleClick="handleClick" />
          </transition>

          <div class="shindan_return" v-show="route.meta.order > 1">
            <a @click="router.back()">
              前の質問に戻る
            </a>
          </div>
        </router-view>
      </div>
    </div>
  </form>
</template>

<script setup>
import { provide } from 'vue'
import { useRouter, useRoute } from 'vue-router'
import { useAnswers } from './composables/answers.js'
import { useQuestions } from './composables/questions.js'
import { useSubmitForm } from '@component_path/composables/submitForm.js'
import { useTimeoutFn } from '@vueuse/core'

const router = useRouter()
const route = useRoute()

const props = defineProps({
  requestParams: { type: Object, required: true },
  masterData: { type: Object, requried: true }
})

const answersStore = useAnswers(props.masterData.tendencyTexts)
const questionsStore = useQuestions(props.masterData.tendencyTexts)
const { submitForm } = useSubmitForm(
  props.requestParams.submitFormUrl,
  props.requestParams.thanksPageUrl,
  props.masterData.formParamKey,
  props.requestParams.authenticityToken
)

const { isPending, start } = useTimeoutFn(() => {}, 500)
const handleClick = (answer, order) => {
  // 次のstepの描画中は画面遷移を無効にする。
  if (isPending.value) { return false }
  start()

  // 回答のセットが成功すれば次の処理、成功しなかった場合にはエラー表示
  setAnswer(answer, order).then(() => {
    // 選択されたら次の質問へ遷移する。最後の質問ならサブミット
    if (questionsStore.isLastQuestion(order)) {
      submitForm(answersStore.answers.value)
    } else {
      router.push(`/step${route.meta.order + 1}`)
    }
  }).catch(() => {
    alert("予想外のエラーが発生しました。\nお手数ですが再度画面を読み込んだ上で、操作をやり直してください。");
  })
};

// 一定時間(timeout)を超えたらreject()
function withTimeout(promise, timeout) {
  const timeoutPromise = new Promise((_, reject) =>
    setTimeout(() => reject(), timeout),
  );
  // Promise.race()を利用して先に解決した方を優先する
  return Promise.race([
    promise, // 本来実行したい promise 関数
    timeoutPromise, // こちらの方が早く解決すると reject()
  ]);
}

// 回答をセットし、その処理が10秒以上掛かる場合にはreject()
async function setAnswer(answer, order) {
  await new Promise((resolve, reject) => {
    // withTimeoutを挟むのはタイムアウトの処理がanswersStore.setと同期処理になり、失敗してもreject()が送信されないため
    withTimeout(answersStore.set(answer, order - 1), 10000).then(() => {
      resolve();
    })
    .catch(()=> {
      reject();
    })
  });
}

provide('questionsStore', questionsStore)
</script>

<style>
/* スライドアニメーション(transition name="jobmatch") */
.shindan-enter-active,
.shindan-leave-active {
  transition: opacity .35s ease;
}
.shindan-enter-from,
.shindan-leave-to {
  transition: all .35s;
  opacity: 0;
}
</style>
